"use strict";

exports.__esModule = true;
exports.useAuditLogDetailsController = useAuditLogDetailsController;
var _react = _interopRequireWildcard(require("react"));
var _AuditLogContext = require("../AuditLogContext");
var _System = require("../../../System");
var _API = require("../../API");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function useAuditLogDetailsController(props) {
  var _React$useContext = _react["default"].useContext(_AuditLogContext.AuditLogContext),
    getAuditLogDetails = _React$useContext.getAuditLogDetails;
  var _useState = (0, _react.useState)(false),
    updateAuditLog = _useState[0],
    setUpdateAuditLog = _useState[1];
  var auditLogId = props.auditLogId,
    onClose = props.onClose,
    refreshData = props.refreshData,
    _props$isFullScreen = props.isFullScreen,
    isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen,
    history = props.history;
  function refreshAuditLogData() {
    if (refreshData) {
      refreshData();
    } else {
      setUpdateAuditLog(!updateAuditLog);
    }
  }
  function handleClose() {
    if (isFullScreen) {
      history.push((0, _System.getScreenURL)("AuditLogList"));
    } else if (onClose) {
      onClose();
    } else {
      console.error("onClose function is not provided");
    }
  }
  var auditLogRequest = _react["default"].useCallback(function () {
    return getAuditLogDetails(auditLogId);
  }, [auditLogId, updateAuditLog]);
  var requests = _react["default"].useMemo(function () {
    return [auditLogRequest];
  }, [auditLogRequest]);
  var _useRequestPromiseLoa = (0, _API.useRequestPromiseLoader)({
      requests: requests
    }),
    isLoading = _useRequestPromiseLoa.loading,
    data = _useRequestPromiseLoa.data,
    error = _useRequestPromiseLoa.error;
  return {
    isLoading: isLoading,
    data: data,
    error: error,
    handleClose: handleClose,
    refreshAuditLogData: refreshAuditLogData
  };
}